import { ShortFileInfoType } from "src/Types/File";
import { GroupListType, ResponseGroups, ResponseUpdateGroups, SortOrder } from "..";

/** Базовый описатель сущности. */
export type PersistentObjectBase = {
	/** Идентификатор. */
    id: string;
};

export enum CustomerType {
	/** Не указано */
    Unknown = -1,
	/** Анонимный заявитель */
    Anonimous = 0,
	/** Физическое лицо */
    Physical = 1,
	/** Индивидуальный предприниматель */
    Individual = 2,
	/** Юридическое лицо */
    Juridical = 3,
	/** Иностранный гражданин */
    Foreign = 4
};











export type ServiceType = {
	serviceFullName?: string;
	serviceDescription?: string;
	categorieses?: any | null;
	lifeSituation?: any | null;
	department?: any | null;
	requiredFiles?: any | null;
	optionalFiles?: any | null;
	canCreateTreatment?: boolean;
	isComplexCustomer?: boolean;
	deloList?: Array<ShortFileInfoType>;
	hasError: boolean;
	errorMessage: string;
};

export type RDCServiceFullInfoType = {
	serviceFullName: string;
	hasError: boolean;
	errorMessage: null | string;

	serviceInfo: RDCServiceInfoType,

	categoryList: Array<string>;
	lifeSituationList: Array<string>;
	subServices: Array<string> // массив наименований подсервисов
	// Массив объектов с краткой информации и организации
	departmentList: Array<DepartmentInfoType>;

	serviceDescription: null | any;
	categorieses: null | any;
	lifeSituation: null | any;
	department: null | any;
	requiredFiles: null | any;
	optionalFiles: null | any;
	canCreateTreatment: boolean;
	isComplexCustomer: boolean;
};

export type DepartmentInfoType = {
	title: string; // Наименование
    director: string; // Управляющий
    phone: string; // Телефон
    schedule: string; // График работы
};

export const CustomerTypes: Array<string> = [ "", "Физическое лицо", "Индивидуальный предприниматель", "Юридическое лицо", "Иностранный гражданин", "Все" ];

export type RDCServiceInfoType = {
	id: string;
	departmentId: string;
	serviceShortName: string;
	serviceFullName: string;
	serviceDescription: string;
	userTypes: Array<number>;

	wikiLink: string;
	epguLink: string;
	isMdmId: string;

	isComplexService: boolean;
	isComplexCustomer: boolean;
	useOneApplicationForComplexUser: boolean;
	isMfcSupport: boolean;
	isOnline: boolean;
	isPopular: boolean;
	isForComplexRequest: boolean;
	isElectronicService: boolean;
	isSkipSelectingCustomer: boolean;
	isExternalDepartmentList: boolean;
	showReceptionButton: boolean;
	serviceDaysType: number;
	serviceStartDay: number;
	templateKey: string;

	subServices: Array<any>,
	interdepartmentalRequestList: any;
	expertComment: null | any;
	paymentList: Array<any>,
	externalDepartmentListSource: null | any;
	serviceDays: null | any;
	serviceDynamicFormRecId: null | string;
	serviceTemplateRecId: null | string;
	rpguServiceTemplateRecId: null | string;
	rpguChargeTemplateRecId: null | string;
	receptionRef: null | any;
	filesNotFound: null | any;
	infoList: any;
	rejectList: any;
	lifeSituationList: Array<any>;
	categoryList: Array<string>;
	linkList: Array<ServiceLinkType>;
	rejectInfos: Array<Record<string, RejectType>>;
	departmentIdList: Array<string>;

	questionList: Record<string, ServiceQuestionType>;
	fileList: Record<string, ServiceFileType>;
	
	departmentsTemplate: Array<ServiceDepartmentTemplateType>;
	passportExtraInfo: ServicePassportInfoType;
};

export type ServiceDepartmentTemplateType = {
	id: string | null;
	indexInSir: string;
	templateLink: string;
	linkId: string;
	departmentId: string;
	departmentName: null | string;
	oivRecipientName: null | string;
	departmentPhone: null | string;
	serviceFullName: null | string;
	isElectronicService: boolean;
	declarantName: null | string;
	templateKey: string;
	declarationZipBytes: null | string;
	useZipDeclaration: boolean;
	questionaryPath: null | string;
	departmentIdList: Array<string>;
	customerTemplateData: null | string;
	templateLinkList: null | string;
	oivRecipientOKTMO: null | string;
	documentName: string;
	serviceRecId: string;
	rpguServiceProcessingTemplate: null | string;
	headName: null | string;
	isMdmId: null | string;
	interdepRequestTemplates: null | string;
	questionAnswer: Record<string, string[]>;
};

export type ServicePassportInfoType = {
	isExtraInfo: boolean;
	submitPeriod: string;
	workDocuments: Array<any>;
	payment: {
		isFree: boolean;
		freeComment: string | null;
		paymentNames: any[];
		paymentInfos: any[];
	}
	completionInfos: Array<{
		id: string;
		title: string;
		comments: string;
		scenarioType: {
			idRef: string;
			title: string;
		},
		outDocuments: any[],
		legalActions: any[]
	}>;
}

export type ServiceQuestionType = {
	id: string;
	questionKey: string | null;
	questionName: string;
	isMultiAnswers: boolean;
	questionAnswerVariants: Array<ServiceQuestionAnswerVariantType>;
};

export type ServiceQuestionAnswerVariantType = {
	id: string;
	name: string;
};

export type ServiceFileType = {
	id: string;
	fileRequired: boolean;
	isMultiDoc: boolean;
	mimeTypes: string | null;
	fileName: string;
	fileDescription: string | null;
};

export type RejectType = {
	id: string;
	isWarning: boolean;
	rejectText: string;
	rejectDescription: string;
};

//два перечисления типа как из c#
export const enum QuestionTypeEnum {
	QuestionFile = 1,
	QuestionQuestion = 2,
	QuestionReject = 3,
	QuestionQuestionAuto = 4,
	QuestionEmpty = 5,
	QuestionService = 6,
	QuestionDynamicForm = 7
};

export const enum LinkTypeEnum {
	And = 1,
	Or = 2,
	Empty = 3,
	Velocity = 4
};

export type ServiceLinkType = {
	key: string;
	value: {
		id: string;
		linkType: number;
		linkObjectId: string;
		questionId: string;
		questionsLinkType: number;
		answerList: Array<string>;
		textCondition: string | null,
	}
};

export type ServiceInfoType = {
	id: string;
	serviceShortName: string;
	serviceFullName: string;
	serviceDescription: string;
	userTypes: Array<number>;
	serviceInfo: RDCServiceInfoType;
	wikiLink: string;
	epguLink: string;
	isMfcSupport: boolean;
	showReceptionButton: boolean;
	categoryList: Array<string>;
	submitPeriod: string|null;
	payment: PaymentInfoType;
	completionInfos: Array<string>;
	rejectInfos: Array<string>;
	subServices: Array<string>;
	lifeSituations: Array<string>;
	interdepartmentalRequestList: Array<string>;
	departmentList: Array<DepartmentInfoType>;
	requiredDocs: Array<string>;
	docs: Array<string>;
};

export type PaymentInfoType = {
	isFree: boolean;
	freeComment: string|null;
	paymentInfos: Array<ServicePaymentInfoItemType>;
};

export type ServicePaymentInfoItemType = {
	title: string;
	groundForAction: string;
	paymentValue: string;
	paymentTypes: Array<string>;
};

/// <summary>
/// Результат оказания услуги заявителю
/// </summary>
export enum ServiceInvocationStatuses
{
	/// <summary>
	/// Результат неизвестен (вероятно услуга не оказывалась)
	/// </summary>
	Unknown,

	/// <summary>
	/// Оказание услуги заявителю возможно
	/// </summary>
	Available,

	/// <summary>
	/// Оказание услуги заявителю невозможно
	/// </summary>
	Rejected
};

export const ServiceInvocationStatus = {
	[ServiceInvocationStatuses.Unknown]: "Анкетирование было пропущено. Возможность оказания услуги не определена.",
	[ServiceInvocationStatuses.Available]: "Услуга может быть оказана заявителю",
	[ServiceInvocationStatuses.Rejected]: "Услуга не может быть оказана заявителю",
};

export type ServiceItemType = {
	epgulink: string | null;
	id: string;
	isFavourite: number;
	name: string;
	subGroupTitle: string|null;
	type: ServiceTypes;
};

export enum ServiceTypes {
	None,
	Mfc,
	Online
};

export type ServicesRequestType = {
	clientDate: Date;
	clientTimezoneOffset: number;
	groupBy?: string;
	sortBy: string;
	sortOrder: SortOrder;
	searchText?: string;	
	type: number;
	groupId?: string;
	location?: string;
	page?: number;
	isComplexRequest?: boolean;
	availableServices?: string[];
};

export type ServicesResponse = ResponseGroups<ServiceItemType>;
export type ServicesGroup = GroupListType<ServiceItemType>;
export type ServiceUpdateGroup = ResponseUpdateGroups<ServiceItemType>;
